export { capitalize } from '@demandstar/components/utils';

export function pluralize(count: number, singular: string, plural: string) {
  if (count === 1) {
    return singular;
  } else {
    return plural;
  }
}
